import { useCallback } from "react";
import { soundManager } from "../utils/audio/audioManager";

export type SoundType = "select" | "click";

// Standalone functions for use outside React components
export const playSelectAudioStandalone = () => {
    try {
        soundManager.play("select", { volume: 0.3 + Math.random() * 0.2 });
    } catch (error) {
        console.error("Error playing select sound:", error);
    }
};

export const playClickAudioStandalone = () => {
    try {
        soundManager.play("click", { volume: 0.3 + Math.random() * 0.2 });
    } catch (error) {
        console.error("Error playing click sound:", error);
    }
};

const useSoundEffect = () => {
    const playSelectAudio = useCallback(() => {
        try {
            soundManager.play("select", { volume: 0.3 + Math.random() * 0.2 });
        } catch (error) {
            console.error("Error playing select sound:", error);
        }
    }, []);

    const playClickAudio = useCallback(() => {
        try {
            soundManager.play("click", { volume: 0.3 + Math.random() * 0.2 });
        } catch (error) {
            console.error("Error playing click sound:", error);
        }
    }, []);

    // Return an object with both functions
    return {
        playSelectAudio,
        playClickAudio,
    };
};

export default useSoundEffect;
